import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import RisorseHero from './components/RisorseHero';
import RisorseList from './components/RisorseList';
import CTASection from './components/CTASection';
import { useSEO } from '../../utils/seo';

export function RisorsePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'Risorse - Guide e Materiali Valutazione Brand Italia',
    description: 'Accedi a guide gratuite, whitepaper, articoli e materiali informativi sulla valutazione del brand. Risorse per aziende, commercialisti e professionisti interessati alla valorizzazione degli asset intangibili.',
    keywords: 'risorse valutazione brand, guide brand valuation, whitepaper marchio, materiali informativi',
    canonical: `${siteUrl}/risorse`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Risorse - Guide e Materiali',
      description: 'Raccolta di risorse, guide e materiali sulla valutazione del brand',
      publisher: {
        '@type': 'Organization',
        name: 'Brand Capital',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <RisorseHero />
      <RisorseList />
      <CTASection />
      <Footer />
    </div>
  );
}
